import { useState, useMemo, useEffect } from 'react'
import { zeroPad } from '@utils'

export const usePartnerWorkTimer = (paused = false) => {
    
    const [seconds, setSeconds] = useState(0)
    const [minutes, setMinutes] = useState(0)
    const [hours, setHours] = useState(0)
    
    const workTimeElapsed = useMemo(() => ({
        seconds,
        minutes,
        hours,
        paddedSeconds: zeroPad(seconds),
        paddedMinutes: zeroPad(minutes),
        paddedHours: zeroPad(hours),
    }), [seconds, minutes, hours])
    
    useEffect(() => {
        if (seconds < 60) return
        setSeconds(0)
        setMinutes(prev => prev + 1)
    }, [seconds])
    
    useEffect(() => {
        if (minutes < 60) return
        setMinutes(0)
        setHours(prev => prev + 1)
    }, [minutes])
    
    useEffect(() => {
        
        if (paused) return
        
        setSeconds(prev => prev + 1)
        
        const t = setInterval(() => setSeconds(prev => prev + 1), 1000)
        
        return () => clearInterval(t)
        
    }, [paused])
    
    return workTimeElapsed
    
}
